export const messages = {
  me: {
    id: "chat-message.me",
    defaultMessage: "Me",
  },
};
